import { createAction, props } from '@ngrx/store';
import { ReqManagerGetTypes } from '../../shared/enums';
import { RequestManagerGet, ResponseReqManagerGet } from '../../shared/interfaces/getRequestManager.interface';

export const getReqManagerGet = createAction(
    ReqManagerGetTypes.REQUEST_MANAGER_GET,
    props<{ request: RequestManagerGet}>()
);

export const getReqManagerGetSucess = createAction(
    ReqManagerGetTypes.REQUEST_MANAGER_GET_SUCCESS,
    props<{ response: ResponseReqManagerGet }>()
);

export const getReqManagerGetError = createAction(
    ReqManagerGetTypes.REQUEST_MANAGER_GET_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    ReqManagerGetTypes.CLEAN_STATE
);
